import Http from '../http'

export const index = (page, name) => Http.get(`/suppliers?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/suppliers', { data }, { headers: { Authorization: localStorage.token } })
export const show = (id) => Http.get(`/suppliers/${id}`, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/suppliers/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/suppliers/${id}`, { headers: { Authorization: localStorage.token } })
